export default {
      id: "instagram-usage",
      viewBox: "0 0 14 14",
      url: "../../assets/" + "sprite.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }